import RIEComboBox from 'components/core/editable/RIEComboBox';
/**
 * Units editable component that validates input against the server's
 * UdunitsController.
 * TODO: would be nice to include a typehead of unit values, if we can parse udunits2 xml files
 * to obtain a consolidated list.
 */
export default class RIEUnits extends RIEComboBox {
    static defaultProps = {
        creatable: true
    };
}



// WEBPACK FOOTER //
// ./src/components/core/editable/RIEUnits.js